import { useCallback } from 'react'
import LogRocket from 'logrocket'

import config from 'config'
import { analytics, apiManager, constants, dateFormatter } from 'helpers'
import { useAuthDispatch, useCustomerSupportWidget, useUpdateUser } from 'hooks'

const {
  AUTH_ACTIONS: { LOGIN, LOGGING },
} = constants

const useLogin = () => {
  const dispatch = useAuthDispatch()
  const { update: updateUser } = useUpdateUser()
  const { initiate } = useCustomerSupportWidget()

  const login = useCallback(
    async ({ chatToken, jwt, userId, newUser }) => {
      dispatch({ type: LOGGING })
      localStorage.chatToken = chatToken
      localStorage.token = jwt
      localStorage.userId = userId

      let user = await apiManager.getMe()
      if (!user.timezone) {
        user = await updateUser({ timezone: dateFormatter.getLongTimeZone() })
      }
      user.newUser = newUser
      dispatch({ type: LOGIN, payload: user })
      analytics.segmentIdentifyAndGroup(user)
      initiate(user)

      const { id, name, email } = user
      if (typeof window.$FPROM !== 'undefined') {
        window.$FPROM.trackSignup({ email }, () => {})
      }
      if (config.node_env === 'production') {
        LogRocket.identify(id, { name, email })
      }
      return user
    },
    [dispatch, updateUser, initiate]
  )

  return login
}

export default useLogin
